<template>
  <div class="ListGroup mt-2">
    <GeneralDropdownListCrud v-model="$v.suppliers.$model"
      placeholder="Leverancier toevoegen"
      endpoint="/api/suppliers"
      search-query="name"
    />
    <GeneralDropdownListCrud v-model="$v.websites.$model"
      placeholder="Website toevoegen"
      endpoint="/api/websites"
      search-query="name"
    />
    <GeneralDropdownListCrud v-model="$v.productgroups.$model"
      placeholder="Productgroep toevoegent"
      endpoint="/api/productgroups"
      search-query="name"
    />
  </div>
</template>

<script>

import GeneralDropdownListCrud from "./GeneralDropdownListCrud.vue"

import setupForm from "../../../../mixins/setupForm"

const fields = ["suppliers", "websites", "productgroups"]
  
export default setupForm(fields, {
  components: {
    GeneralDropdownListCrud,
  },
})

</script>

<style scoped>

.ListGroup {
  margin-bottom: 100px;
}

</style>
